module.exports = __webpack_public_path__ + "img/lsp-workshop-step-1.ecc41aa3.jpg";